import BaseSensor from './BaseSensor'

export default class Pressure extends BaseSensor {
  protected getDisplayReading(readingValue?: number): number | undefined {
    return readingValue
  }
}
